const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

const CHAT = {
  // Main AI chat endpoint
  MESSAGE: `${API_BASE_URL}/chat/message/`,
  SERVICE_PROVIDER: `${API_BASE_URL}/chat/service-provider/`,
};

export default CHAT;